import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';
import { 
  FaCheckCircle, 
  FaTimesCircle, 
  FaBolt, 
  FaInfinity, 
  FaCalendarCheck, 
  FaDownload, 
  FaRocket,
  FaLayerGroup,
  FaUserShield,
  FaQuestionCircle,
  FaUserClock
} from 'react-icons/fa';

const Pricing = () => {
  return (
    <div className="pricing-page">
      {/* SVG Definitions for Patterns */}
      <svg 
        width="0" 
        height="0" 
        style={{ position: 'absolute' }}
      >
        <defs>
          <pattern 
            id="gridPattern" 
            width="20" 
            height="20" 
            patternUnits="userSpaceOnUse"
          >
            <path 
              d="M 20 0 L 0 0 0 20" 
              fill="none" 
              stroke="white" 
              strokeWidth="0.5" 
              opacity="0.3"
            />
          </pattern>
        </defs>
      </svg>

      <div className="pricing-hero">
        <div className="pricing-hero__overlay">
          <svg 
            width="100%" 
            height="100%" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect 
              width="100%" 
              height="100%" 
              fill="url(#gridPattern)" 
            />
          </svg>
        </div>
        <div className="pricing-container">
          <h1 className="pricing-hero__title">Simple, Transparent Pricing</h1>
          <p className="pricing-hero__subtitle">Choose the plan that works best for your job search journey</p>
        </div>
      </div>

      <div className="pricing-container">
        {/* Notification Banner */}
        <div className="pricing-notification">
          <div className="pricing-notification__icon">
            <FaBolt style={{ color: '#fff', fontSize: '1.3rem' }} />
          </div>
          <p className="pricing-notification__text">
            🚨 Premium & Ultra plans are currently in testing phase and will be available soon! 🚨
          </p>
        </div>
        
        <div className="pricing-intro">
          <h2 className="pricing-intro__title">Resume Tailoring Credits</h2>
          <p className="pricing-intro__text">
            Each credit allows you to tailor one resume for a specific job description. 
            Our AI-powered system analyzes the job requirements and optimizes your resume 
            to highlight your most relevant skills and experiences, increasing your chances 
            of getting past ATS systems and landing interviews.
          </p>
        </div>

        <div className="pricing-plans">
          <div className="pricing-plan">
            <h3 className="pricing-plan__name">Basic</h3>
            <div className="pricing-plan__price">
              <span className="pricing-plan__currency"></span>
              <span className="pricing-plan__amount">Free</span>
              <span className="pricing-plan__period"></span>
            </div>
            <div className="pricing-plan__credits">
              <span className="pricing-plan__credits-amount">5 Credits</span>
              <p className="pricing-plan__credits-text">Per Day</p>
            </div>
            <div className="pricing-plan__features">
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>ATS-friendly resume optimization</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Job search access via OppLiy</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Basic profile management</span>
              </div>
              <div className="pricing-plan__feature">
                <FaTimesCircle className="pricing-plan__feature-icon" style={{ color: '#ccc' }} />
                <span>Priority support</span>
              </div>
              <div className="pricing-plan__feature">
                <FaTimesCircle className="pricing-plan__feature-icon" style={{ color: '#ccc' }} />
                <span>Advanced analytics</span>
              </div>
            </div>
            <Link to="/register" className="pricing-plan__cta pricing-plan__cta--outline">
              Get Started Free
            </Link>
          </div>

          <div className="pricing-plan pricing-plan--popular pricing-plan--testing">
            <h3 className="pricing-plan__name">Premium</h3>
            <div className="pricing-plan__price">
              <span className="pricing-plan__currency">$</span>
              <span className="pricing-plan__amount">10</span>
              <span className="pricing-plan__period">/mo</span>
            </div>
            <div className="pricing-plan__credits">
              <span className="pricing-plan__credits-amount">3,000 Credits</span>
              <p className="pricing-plan__credits-text">Per Month</p>
              <p style={{ 
                fontSize: '0.8rem', 
                color: '#664d03', 
                backgroundColor: 'rgba(255, 193, 7, 0.2)', 
                padding: '0.3rem 0.5rem', 
                borderRadius: '4px',
                marginTop: '0.5rem'
              }}>
                Currently in testing - Coming soon
              </p>
            </div>
            <div className="pricing-plan__features">
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>ATS-friendly resume optimization</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Job search access via OppLiy</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Enhanced profile management</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Priority support</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Basic application tracking</span>
              </div>
            </div>
            <button className="pricing-plan__cta" disabled style={{ 
              opacity: '0.7', 
              cursor: 'not-allowed',
              backgroundColor: '#889af0',
              boxShadow: 'none'
            }}>
              Coming Soon
            </button>
          </div>

          <div className="pricing-plan pricing-plan--testing">
            <h3 className="pricing-plan__name">Ultra</h3>
            <div className="pricing-plan__price">
              <span className="pricing-plan__currency">$</span>
              <span className="pricing-plan__amount">20</span>
              <span className="pricing-plan__period">/mo</span>
            </div>
            <div className="pricing-plan__credits">
              <span className="pricing-plan__credits-amount">
                <FaInfinity style={{ fontSize: '1.5rem' }} /> Unlimited
              </span>
              <p className="pricing-plan__credits-text">Credits</p>
              <p style={{ 
                fontSize: '0.8rem', 
                color: '#664d03', 
                backgroundColor: 'rgba(255, 193, 7, 0.2)', 
                padding: '0.3rem 0.5rem', 
                borderRadius: '4px',
                marginTop: '0.5rem'
              }}>
                Currently in testing - Coming soon
              </p>
            </div>
            <div className="pricing-plan__features">
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>ATS-friendly resume optimization</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Premium job search features</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Advanced profile management</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Priority support with 24-hour response</span>
              </div>
              <div className="pricing-plan__feature">
                <FaCheckCircle className="pricing-plan__feature-icon" />
                <span>Advanced application tracking & analytics</span>
              </div>
            </div>
            <button className="pricing-plan__cta" disabled style={{ 
              opacity: '0.7', 
              cursor: 'not-allowed',
              backgroundColor: '#889af0',
              boxShadow: 'none'
            }}>
              Coming Soon
            </button>
          </div>
        </div>

        <div className="pricing-comparison">
          <h2 className="pricing-comparison__title">Feature Comparison</h2>
          <div style={{ overflowX: 'auto' }}>
            <table className="pricing-table">
              <thead>
                <tr>
                  <th>Features</th>
                  <th>Basic</th>
                  <th>Premium</th>
                  <th>Ultra</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Resume Tailoring Credits</td>
                  <td>5 per day</td>
                  <td>3,000 per month</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>ATS-Friendly Optimization</td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                </tr>
                <tr>
                  <td>Job Search via OppLiy</td>
                  <td>Basic</td>
                  <td>Enhanced</td>
                  <td>Premium</td>
                </tr>
                <tr>
                  <td>Job Alert Notifications</td>
                  <td>Basic (Weekly)</td>
                  <td>Enhanced (Daily)</td>
                  <td>Premium (Real-time)</td>
                </tr>
                <tr>
                  <td>Resume Versions Saved</td>
                  <td>3</td>
                  <td>20</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Application Tracking</td>
                  <td><FaTimesCircle className="pricing-table__cross" /></td>
                  <td>Basic</td>
                  <td>Advanced</td>
                </tr>
                <tr>
                  <td>Success Analytics & Insights</td>
                  <td><FaTimesCircle className="pricing-table__cross" /></td>
                  <td>Basic</td>
                  <td>Advanced</td>
                </tr>
                <tr>
                  <td>Interview Preparation Assistance</td>
                  <td><FaTimesCircle className="pricing-table__cross" /></td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                </tr>
                <tr>
                  <td>Priority Support</td>
                  <td><FaTimesCircle className="pricing-table__cross" /></td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                  <td><FaCheckCircle className="pricing-table__check" /></td>
                </tr>
                <tr>
                  <td>Support Response Time</td>
                  <td>48 hours</td>
                  <td>24 hours</td>
                  <td>Priority (12 hours)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="pricing-faq">
          <h2 className="pricing-faq__title">Frequently Asked Questions</h2>
          <div className="pricing-faq-grid">
            <div className="pricing-faq-item">
              <h3 className="pricing-faq-item__question">
                <FaQuestionCircle className="pricing-faq-item__question-icon" />
                <span>What are resume tailoring credits?</span>
              </h3>
              <p className="pricing-faq-item__answer">
                Resume tailoring credits allow you to optimize your resume for a specific job description. Each credit lets you create one tailored version of your resume that highlights your most relevant skills and experiences for that particular job.
              </p>
            </div>

            <div className="pricing-faq-item">
              <h3 className="pricing-faq-item__question">
                <FaQuestionCircle className="pricing-faq-item__question-icon" />
                <span>Do unused credits roll over?</span>
              </h3>
              <p className="pricing-faq-item__answer">
                Basic plan credits reset daily and do not roll over. For Premium plans, credits are refreshed monthly and do not carry over to the next billing cycle. Ultra plan offers unlimited credits with no need to track usage.
              </p>
            </div>

            <div className="pricing-faq-item">
              <h3 className="pricing-faq-item__question">
                <FaQuestionCircle className="pricing-faq-item__question-icon" />
                <span>Can I change plans at any time?</span>
              </h3>
              <p className="pricing-faq-item__answer">
                Yes, you can upgrade or downgrade your plan at any time. When upgrading, the new features will be available immediately. When downgrading, the current plan remains active until the end of the billing cycle.
              </p>
            </div>

            <div className="pricing-faq-item">
              <h3 className="pricing-faq-item__question">
                <FaQuestionCircle className="pricing-faq-item__question-icon" />
                <span>Is there a free trial for paid plans?</span>
              </h3>
              <p className="pricing-faq-item__answer">
                While we don't offer a traditional trial, our Basic plan is completely free and gives you a good sense of our core features. You can use the free credits daily to test our resume tailoring system before committing to a paid plan.
              </p>
            </div>

            <div className="pricing-faq-item">
              <h3 className="pricing-faq-item__question">
                <FaQuestionCircle className="pricing-faq-item__question-icon" />
                <span>What payment methods do you accept?</span>
              </h3>
              <p className="pricing-faq-item__answer">
                We accept all major credit cards (Visa, Mastercard, American Express, Discover) and PayPal for subscription payments. All transactions are securely processed and your payment information is never stored on our servers.
              </p>
            </div>

            <div className="pricing-faq-item">
              <h3 className="pricing-faq-item__question">
                <FaQuestionCircle className="pricing-faq-item__question-icon" />
                <span>How do I cancel my subscription?</span>
              </h3>
              <p className="pricing-faq-item__answer">
                You can cancel your subscription at any time through your account settings. Navigate to "Account" - "Subscription" and click on "Cancel Subscription". Your access to premium features will continue until the end of your current billing period.
              </p>
            </div>
          </div>
        </div>

        <div className="pricing-cta">
          <div className="pricing-cta__content">
            <h2 className="pricing-cta__title">Ready to Supercharge Your Job Search?</h2>
            <p className="pricing-cta__text">
              Join thousands of job seekers who are using CVance & OppLiy to streamline their 
              application process and increase their chances of landing interviews.
            </p>
            <Link to="/register" className="pricing-cta__button">
              Get Started Today
            </Link>
          </div>
        </div>

        <section className="pricing-disclaimer">
          <div className="disclaimer-content">
            <h3 className="disclaimer-title">Project Status Disclaimer</h3>
            <p className="disclaimer-text">
              CVance and OppLiy are currently in the project development phase. We are not a registered 
              company or LLC at this time. This is a non-profit project aimed at addressing challenges 
              in the job search process. The platforms and services described are under development and 
              subject to change. Any information provided is for informational purposes only and does not 
              constitute a commercial offering or binding agreement.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Pricing;